import {$clientApi} from "../http";
import {
    ICustomerLoyaltyBalance,
    ILoyaltyPointsExchangesForCustomer,
    ILoyaltyPointsHistory
} from "../models/LoyaltyPoints";

class LoyaltyPointsServiceClass {

    async getCustomersLoyaltyPointsBalance(customerId: number) {
        return $clientApi.get<{
            data: ICustomerLoyaltyBalance,
            success: boolean
        }>(`api/loyalty-points-customer-balance/get-by-customerId/${customerId}`);
    }

    async getLoyaltyPointsHistory(customerId: number | null, limit: number | null, skip: number | null) {
        return $clientApi.get<{
            data: { historyItems: ILoyaltyPointsHistory[], historyItemsLength: number },
            success: boolean
        }>(`api/loyalty-points-history/?customerId=${customerId}&limit=${limit}&skip=${skip}`);
    }

    async getExchangesForCustomer() {
        return  $clientApi.get<{
            data: ILoyaltyPointsExchangesForCustomer[],
            success: boolean
        }>(`api/loyalty-points-settings/exchanges-for-customer`);
    }

}

export const LoyaltyPointsService = new LoyaltyPointsServiceClass();